import { appConfig } from '@/config';
const endpoint = () => new URL('/business-api/registration.php', appConfig.serviceOrigin);
export async function registrationRequest(body) {
  const response = await fetch(endpoint(), body ? {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit'
  } : { cache: 'no-store', credentials: 'omit' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) {
    const error = new Error(data.message || 'Registration service unavailable');
    error.code = data.error_code || 'failed';
    error.matches = Array.isArray(data.matches) ? data.matches : [];
    throw error;
  }
  return data;
}

const errorCodes = new Set(['usernameInvalid', 'phoneInvalid', 'emailInvalid', 'invalidCode', 'passwordInvalid', 'methodClosed', 'modeChanged', 'tooMany', 'retryLater', 'createFailed', 'invalidRequest', 'referrerNotFound', 'referrerMultiple', 'referrerTooMany']);
export function registrationErrorKey(error) {
  return `registration.${errorCodes.has(error?.code) ? error.code : 'failed'}`;
}

export async function resolveRegistrationLogin(identity) {
  try {
    const response = await registrationRequest({ action: 'resolve_login', identity });
    return response.account || null;
  } catch (error) {
    if (/^\+?[0-9\s()-]+$/.test(identity)) return null;
    throw error;
  }
}
